function initSlider(){
    $('.mrk-main-slider').slick({
        infinite: false,
        slidesToShow: 1,
        fade:true,
        slidesToScroll: 1,
        arrows: true,
        asNavFor : '.mrk-thumbnail-slider',
        prevArrow: '<button class="slick-prev slick-arrow mrk-prev-arrow" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next slick-arrow mrk-next-arrow" aria-label="Next" type="button">Next</button>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                adaptiveHeight: true,
                infinite: false,
              }
            },
          {
              breakpoint: 768,
              settings: {
                adaptiveHeight: true,
                infinite: false,
              }
            }
          ]
    });
    $('.mrk-thumbnail-slider').slick({
        infinite: false,
        centerMode:false,
        centerPadding: '0px',
        slidesToShow: 3.95,
        slidesToScroll: 1,
        arrows: false,
        vertical: true,
        focusOnSelect: true,
        asNavFor : '.mrk-main-slider',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                centerMode:false,
                vertical: false
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3.5,
                vertical: false,
                centerMode:false,
                infinite: false,
                slidesToScroll: 1,
              }
            }
        ]
    });
}
function initCollectionSliders(){
    $('.pro-featured-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
function selectCMOption() {
  console.log('hello');
    $('[value="cm"]:eq(0)').each(function() {
        $(this).prop('selected', true);
        var selectElement = $(this).parents('select')[0];
        if (selectElement) {
            var event = new Event('change', {
                bubbles: true,
                cancelable: true
            });
            selectElement.dispatchEvent(event);
        }
    });
}
initSlider();
initCollectionSliders();
document.addEventListener('shopify:section:reorder', () => initCollectionSliders());

document.addEventListener('shopify:section:select', () => initCollectionSliders());

document.addEventListener('shopify:section:deselect', () => initCollectionSliders());

document.addEventListener('shopify:inspector:activate', () => initCollectionSliders());

document.addEventListener('shopify:inspector:deactivate', () => initCollectionSliders());
const sizeModal_size_general = () => {
  const sizes_modal = {
    "tops-*-30+-+32:A": "XS",
    "tops-*-bust-30+-+32": "XS",
    "tops-*-cup-A": "XS",
    "tops-*-32+-+34:B+-+C": "S",
    "tops-*-bust-32+-+34": "S",
    "tops-*-cup-B+-+C": "S",
    "tops-*-34+-+36:B+-+C": "M",
    "tops-*-bust-34+-+36": "M",
    "tops-*-cup-B+-+C": "M",
    "tops-*-36+-+38:XL-+D": "L",
    "tops-*-bust-36+-+38": "L",
    "tops-*-cup-XL-+D": "L",
    "tops-*-38+-+40:D": "XL",
    "tops-*-bust-38+-+40": "XL",
    "tops-*-cup-D": "XL",
    "tops-underwire-30+-+32:A": "XS",
    "tops-underwire-bust-30+-+32": "XS",
    "tops-underwire-cup-A": "XS",
    "tops-underwire-32+-+34:B": "S",
    "tops-underwire-bust-32+-+34": "S",
    "tops-underwire-cup-B": "S",
    "tops-underwire-34+-+36:C": "M",
    "tops-underwire-bust-34+-+36": "M",
    "tops-underwire-cup-C": "M",
    "tops-underwire-36+-+38:D": "L",
    "tops-underwire-bust-36+-+38": "L",
    "tops-underwire-cup-D": "L",
    "tops-underwire-38+-+40:D": "XL",
    "tops-underwire-bust-38+-+40": "XL",
    "tops-underwire-cup-D": "XL",
    "bottoms-*-24+-+25:33.5+-+36": "XS",
    "bottoms-*-waist-24+-+25": "XS",
    "bottoms-*-hip-33.5+-+36": "XS",
    "bottoms-*-25+-+26:36+-+38": "S",
    "bottoms-*-waist-25+-+26": "S",
    "bottoms-*-hip-36+-+38": "S",
    "bottoms-*-27+-+28:38+-+39": "M",
    "bottoms-*-waist-27+-+28": "M",
    "bottoms-*-hip-38+-+39": "M",
    "bottoms-*-29+-+30:39+-+40": "L",
    "bottoms-*-waist-29+-+30": "L",
    "bottoms-*-hip-39+-+40": "L",
    "bottoms-*-31+-+33:40+-+41": "XL",
    "bottoms-*-waist-31+-+33": "XL",
    "bottoms-*-hip-40+-+41": "XL",
    "one pieces-*-30+-+32:A:24+-+25:33.5+-+36": "XS",
    "one pieces-*-bust-30+-+32": "XS",
    "one pieces-*-cup-A": "XS",
    "one pieces-*-waist-24+-+25": "XS",
    "one pieces-*-hip-33.5+-+36": "XS",
    "one pieces-*-32+-+34:B+-+C:25+-+26:36+-+38": "S",
    "one pieces-*-bust-32+-+34": "S",
    "one pieces-*-cup-B+-+C": "S",
    "one pieces-*-waist-25+-+26": "S",
    "one pieces-*-hip-36+-+38": "S",
    "one pieces-*-34+-+36:B+-+C:27+-+28:38+-+39": "M",
    "one pieces-*-bust-34+-+36": "M",
    "one pieces-*-cup-B+-+C": "M",
    "one pieces-*-waist-27+-+28": "M",
    "one pieces-*-hip-38+-+39": "M",
    "one pieces-*-36+-+38:XL-+D:29+-+30:39+-+40": "L",
    "one pieces-*-bust-36+-+38": "L",
    "one pieces-*-cup-XL-+D": "L",
    "one pieces-*-waist-29+-+30": "L",
    "one pieces-*-hip-39+-+40": "L",
    "one pieces-*-38+-+40:D:31+-+33:40+-+41": "XL",
    "one pieces-*-bust-38+-+40": "XL",
    "one pieces-*-cup-D": "XL",
    "one pieces-*-waist-31+-+33": "XL",
    "one pieces-*-hip-40+-+41": "XL",
    "men&#39;s-*-28+-+30": "XS",
    "men&#39;s-*-waist-28+-+30": "XS",
    "men&#39;s-*-30+-+32": "S",
    "men&#39;s-*-waist-30+-+32": "S",
    "men&#39;s-*-32+-+33": "M",
    "men&#39;s-*-waist-32+-+33": "M",
    "men&#39;s-*-33+-+34": "L",
    "men&#39;s-*-waist-33+-+34": "L",
  };

  let active_type = document.querySelector("#size-general .sizes__type.active")
      .dataset.type,
    active_subtype = "*";

  // Change type
  const setActiveType = () => {
    document
      .querySelectorAll("#size-general .sizes__block [data-type]")
      .forEach((item) => {
        item.style.display = item.dataset.type === active_type ? "" : "none";
      });
  };

  const setActiveSubtype = () => {
    document
      .querySelectorAll("#size-general .sizes__block [data-subtype]")
      .forEach((item) => {
        item.style.display =
          item.dataset.subtype === active_subtype ? "" : "none";
      });
  };

  setActiveType();
  setActiveSubtype();

  document.querySelectorAll("#size-general .sizes__type").forEach((item) =>
    item.addEventListener("click", () => {
      document
        .querySelector("#size-general .sizes__type.active")
        .classList.remove("active");
      item.classList.add("active");

      active_type = item.dataset.type;
      active_subtype = "*";

      setActiveType();
      setActiveSubtype();

      subtype_selects.forEach(
        (subtype_select) => (subtype_select.selectedIndex = 0)
      );
    })
  );

  const subtype_selects = document.querySelectorAll(
    "#size-general .sizes [data-subtype-select]"
  );

  subtype_selects.forEach((item) =>
    item.addEventListener("change", () => {
      subtype_selects.forEach(
        (subtype_select) => (subtype_select.value = item.value)
      );

      active_subtype = item.value;
      setActiveSubtype();
    })
  );

  document
    .querySelectorAll("#size-general .sizes__nav-item")
    .forEach((item, key) =>
      item.addEventListener("click", () => {
        // Menu
        document
          .querySelector("#size-general .sizes__nav-item.active")
          .classList.remove("active");
        item.classList.add("active");

        // Block
        document
          .querySelector("#size-general .sizes__block:not(.visually-hidden)")
          .classList.add("visually-hidden");
        document
          .querySelector(`#size-general .sizes__block:nth-child(${key + 1})`)
          .classList.remove("visually-hidden");
      })
    );

  // Calculator
  const sizes_keys = Object.keys(sizes_modal);

  document
    .querySelector("#size-general .sizes__form")
    .addEventListener("submit", (e) => {
      e.preventDefault();

      const data = new FormData(e.target),
        full_key = `${active_type}-${active_subtype}-${Object.values(
          Object.fromEntries(data)
        ).join(":")}`;

      let size = "",
        current_key = -1;

      if (sizes_modal[full_key]) {
        size = sizes_modal[full_key];
      } else {
        for (const pair of data.entries()) {
          if (pair[1] !== "0") {
            const key = `${active_type}-${active_subtype}-${pair[0]}-${pair[1]}`;

            if (sizes_keys.indexOf(key) > current_key) {
              size = sizes_modal[key];
              current_key = sizes_keys.indexOf(key);
            }
          }
        }
      }

      if (size) {
        size = new DOMParser().parseFromString(size, "text/html");
        size = size.documentElement.textContent;

        e.target.querySelector(".main-form__result span").innerText =
          decodeURI(size);
        e.target.querySelector(".main-form__result").classList.add("active");
      }
    });

  // Measures
  const convert = (item, elem) => {
    if (!isNaN(parseInt(elem.innerText))) {
      if (item.value === "cm") {
        const texts = elem.innerText.split("-");

        for (let i in texts) {
          texts[i] = (parseInt(texts[i]) * 2.54).toFixed();
        }

        elem.innerText = texts.join(" - ");
      } else {
        elem.innerText = elem.dataset.original;
      }
    }
  };

  document
    .querySelectorAll(
      "#size-general .sizes select[data-render-select], #size-general .sizes select[data-render-table]"
    )
    .forEach((item) => {
      item.addEventListener("change", () => {
        document.querySelector(
          "#size-general .sizes select[data-render-select]"
        ).value = item.value;
        document.querySelector(
          "#size-general .sizes select[data-render-table]"
        ).value = item.value;

        document
          .querySelectorAll("#size-general .sizes__tables td")
          .forEach((elem) => convert(item, elem));
        document
          .querySelectorAll("#size-general .sizes__form select option")
          .forEach((elem) => convert(item, elem));
      });
    });
  selectCMOption();
};
document.querySelectorAll("[data-modal-toggle]").forEach((t) => {
  t.addEventListener("click", () => {
    document.querySelector(t.dataset.modalToggle).classList.toggle("active");
  });
});
sizeModal_size_general();